<template>
  <div class="add-shop-container">
    <el-card class="form-card" shadow="never">
      <div slot="header" class="card-header">
        <span class="title">注册店铺</span>
        <span class="sub-title">请填写店铺详细信息</span>
      </div>

      <el-form
        ref="shopForm"
        :model="shopInfo"
        :rules="formRules"
        label-width="140px"
        label-position="right"
        class="shop-form"
      >
        <!-- 基本信息区域 -->
        <div class="form-section">
          <div class="section-title">基本信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="店铺名称" prop="sh_name">
                <el-input v-model="shopInfo.sh_name" placeholder="请输入店铺名称" maxlength="100" show-word-limit />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="comlist_v1">
                <el-input v-model="shopInfo.comlist_v1" placeholder="请输入手机号" maxlength="11" show-word-limit />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="档口号">
                <el-input v-model="shopInfo.comlist_v3" placeholder="请输入档口号" maxlength="50" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="店铺类型">
                <el-select v-model="shopInfo.comlist_v8" placeholder="请选择店铺类型" clearable>
                  <el-option
                    v-for="item in shopTypeOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="所在地区">
                <el-select
                  v-model="selectedRegion"
                  placeholder="请选择地区"
                  clearable
                  @change="onRegionChange"
                >
                  <el-option
                    v-for="item in regionList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在市场">
                <el-select
                  v-model="selectedMarket"
                  placeholder="请选择市场"
                  clearable
                  :disabled="!selectedRegion"
                  @change="onMarketChange"
                >
                  <el-option
                    v-for="item in marketList"
                    :key="item.market_id"
                    :label="item.market_name"
                    :value="item.market_name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row> -->

          <el-form-item label="店铺地址">
            <el-input v-model="shopInfo.comlist_v4" type="textarea" :rows="2" placeholder="请输入详细店铺地址" maxlength="200" show-word-limit />
          </el-form-item>

          <el-form-item label="店铺公告">
            <el-input v-model="shopInfo.comlist_m1" type="textarea" :rows="3" placeholder="请输入店铺公告（选填）" maxlength="1000" show-word-limit />
          </el-form-item>
        </div>

        <!-- 证件与图片区域 -->
        <div class="form-section">
          <div class="section-title">证件与图片</div>
          <el-form-item label="店铺头像">
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :http-request="handleLogoUpload"
              :before-upload="beforeLogoUpload"
            >
              <img v-if="shopInfo.mem_img" :src="shopInfo.mem_img" class="avatar-img" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">建议尺寸200*200，支持jpg/png，不超过2MB</div>
          </el-form-item>

          <el-form-item label="营业执照">
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :http-request="handleLicenseUpload"
              :before-upload="beforeLicenseUpload"
            >
              <img v-if="shopInfo.zhi_img" :src="shopInfo.zhi_img" class="avatar-img" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">支持jpg/png，不超过5MB</div>
          </el-form-item>
        </div>

        <!-- 经营信息区域 -->
        <div class="form-section">
          <div class="section-title">经营信息</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="销售类型">
                <el-input v-model="shopInfo.comlist_v5" placeholder="例：批发/零售" maxlength="100" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="店铺推荐人">
                <el-input v-model="shopInfo.comlist_v7" placeholder="推荐人姓名" maxlength="50" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="经营范围" prop="comlist_v6">
            <el-checkbox-group v-model="selectedSalesTypesValues" @change="onSalesTypeChange">
              <el-checkbox
                v-for="item in salesTypeOptions"
                :key="item.value"
                :label="item.value"
                border
                class="sales-checkbox"
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
            <div class="form-tip">可多选</div>
          </el-form-item>
        </div>

        <!-- 企业信息区域（选填） -->
        <div class="form-section">
          <div class="section-title">企业信息（选填）</div>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="企业名称">
                <el-input v-model="shopInfo.comlist_v9" placeholder="营业执照企业名称" maxlength="100" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="统一社会信用代码">
                <el-input v-model="shopInfo.comlist_v10" placeholder="18位统一代码" maxlength="18" show-word-limit />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="营业执照有效期">
                <el-input v-model="shopInfo.comlist_v11" placeholder="长期 / 2025-12-31" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业地址">
                <el-input v-model="shopInfo.comlist_v12" placeholder="注册地址" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="法人姓名">
                <el-input v-model="shopInfo.comlist_v13" placeholder="法人代表" maxlength="20" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号">
                <el-input v-model="shopInfo.comlist_v14" placeholder="身份证号码" maxlength="18" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="身份证有效期">
            <el-input v-model="shopInfo.comlist_v15" placeholder="长期 / 2025-12-31" />
          </el-form-item>
        </div>

        <!-- 提交按钮 -->
        <div class="form-actions">
          <el-button type="primary" size="medium" :loading="submitting" @click="submitForm">确认添加</el-button>
          <el-button size="medium" @click="resetForm">重置</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie'

const token = Cookie.get('token')
const Request = axios.create({
  withCredentials: true,
  headers: {
    // 'Content-Type': 'application/x-www-form-urlencoded',
    'Content-Type': 'application/json',
    // 'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})
// 接口配置
const API_BASE = 'https://caixiao.lianglianyn.com'
const REGION_API = `${API_BASE}/index/get_region_list.php`
const MARKET_API = `${API_BASE}/index/get_region_list.php`
const UPLOAD_LOGO_API = `${API_BASE}/index/upload_dian.php`
const UPLOAD_LICENSE_API = `${API_BASE}/index/upload_dian_zhi.php`
const SUBMIT_API = `${API_BASE}/sh/sh_jiben_add.php`
//  `${API_BASE}/index/add_shop_info.php`
// `${API_BASE}/admin/dianpu_jiben_edit.php`

export default {
  name: 'AddShop',
  data () {
    // 自定义手机号校验
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系电话'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的11位手机号'))
      } else {
        callback()
      }
    }
    return {
      shopInfo: {
        sh_name: '',
        comlist_v1: '',
        mem_img: '',
        zhi_img: '',
        comlist_v2: '', // 市场名称
        comlist_v2_1: '', // 市场ID
        comlist_v2_2: '', // 地区名称
        comlist_v3: '',
        comlist_v4: '',
        comlist_v5: '', // 销售类型(文本)
        comlist_v6: '', // 经营范围(逗号分隔)
        comlist_v7: '',
        comlist_v8: '',
        comlist_v9: '',
        comlist_v10: '',
        comlist_v11: '',
        comlist_v12: '',
        comlist_m1: '',
        comlist_v13: '',
        comlist_v14: '',
        comlist_v15: ''
      },
      // 表单校验规则
      formRules: {
        sh_name: [{ required: true, message: '请输入店铺名称', trigger: 'blur' }],
        comlist_v1: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        comlist_v6: [{ required: false, message: '请选择经营范围', trigger: 'change' }]
      },
      // 店铺类型选项
      shopTypeOptions: ['企业', '个体工商户', '小微商户'],
      // 经营范围选项
      salesTypeOptions: [
        { label: '水果', value: '水果' },
        { label: '蔬菜', value: '蔬菜' },
        { label: '冻品', value: '冻品' },
        { label: '水产', value: '水产' },
        { label: '菌菇', value: '菌菇' },
        { label: '肉禽蛋奶', value: '肉禽蛋奶' },
        { label: '副食饮料', value: '副食饮料' },
        { label: '粮油调味', value: '粮油调味' },
        { label: '其他', value: '其他' }
      ],
      // 地区和市场相关数据
      regionList: [
        { id: 1, name: '北京市' },
        { id: 2, name: '天津市' },
        { id: 3, name: '河北省' },
        { id: 4, name: '山西省' },
        { id: 5, name: '内蒙古自治区' },
        { id: 6, name: '辽宁省' },
        { id: 7, name: '吉林省' },
        { id: 8, name: '黑龙江省' },
        { id: 9, name: '上海市' },
        { id: 10, name: '江苏省' },
        { id: 11, name: '浙江省' },
        { id: 12, name: '安徽省' },
        { id: 13, name: '福建省' },
        { id: 14, name: '江西省' },
        { id: 15, name: '山东省' },
        { id: 16, name: '河南省' },
        { id: 17, name: '湖北省' },
        { id: 18, name: '湖南省' },
        { id: 19, name: '广东省' },
        { id: 20, name: '广西壮族自治区' },
        { id: 21, name: '海南省' },
        { id: 22, name: '重庆市' },
        { id: 23, name: '四川省' },
        { id: 24, name: '贵州省' },
        { id: 25, name: '云南省' },
        { id: 26, name: '西藏自治区' },
        { id: 27, name: '陕西省' },
        { id: 28, name: '甘肃省' },
        { id: 29, name: '青海省' },
        { id: 30, name: '宁夏回族自治区' },
        { id: 31, name: '新疆维吾尔自治区' },
        { id: 32, name: '台湾省' },
        { id: 33, name: '香港特别行政区' },
        { id: 34, name: '澳门特别行政区' }
      ],
      marketList: [],
      selectedRegion: '',
      selectedMarket: '',
      selectedMarketId: '',
      // 上传相关
      submitting: false,
      // token等从localStorage获取（演示环境可mock，真实使用时需登录后存储）
      userToken: '',
      userName: '',
      userType: ''
    }
  },
  computed: {
    // 经营范围绑定数组
    selectedSalesTypesValues: {
      get () {
        if (!this.shopInfo.comlist_v6) return []
        return this.shopInfo.comlist_v6.split(',').filter(v => v)
      },
      set (val) {
        this.shopInfo.comlist_v6 = val.join(',')
      }
    }
  },
  created () {
    this.initUserData()
  },
  methods: {
    // 初始化用户信息（实际应从登录后存储获取，这里模拟或从localStorage读取）
    initUserData () {
      // 模拟从本地存储获取用户凭证，实际开发按需调整
      this.userToken = Cookie.get('token')
      this.userName = localStorage.getItem('user_name')
      this.shopInfo.comlist_v9 = localStorage.getItem('comname')
      this.shopInfo.comlist_v10 = localStorage.getItem('comcode')
    },

    // 获取地区列表
    async fetchRegionList () {
      try {
        const res = await Request.post(REGION_API, {})
        if (res.data && Array.isArray(res.data)) {
          this.regionList = res.data
        } else {
          console.error('地区列表数据异常', res)
          this.$message.error('获取地区列表失败')
        }
      } catch (error) {
        console.error('获取地区失败', error)
        this.$message.error('网络错误，请刷新重试')
      }
    },

    // 获取市场列表
    async fetchMarketList (regionName) {
      if (!regionName) return
      try {
        const res = await Request.post(MARKET_API, { name: regionName })
        if (res.data && res.data.data) {
          this.marketList = res.data.data
        } else {
          this.marketList = []
          this.$message.warning('该地区暂无市场数据')
        }
      } catch (error) {
        console.error('获取市场失败', error)
        this.marketList = []
        this.$message.error('获取市场列表失败')
      }
    },

    // 地区变更
    onRegionChange (val) {
      this.selectedMarket = ''
      this.shopInfo.comlist_v2 = ''
      this.shopInfo.comlist_v2_1 = ''
      this.shopInfo.comlist_v2_2 = val || ''
      if (val) {
        this.fetchMarketList(val)
      } else {
        this.marketList = []
      }
    },

    // 市场变更
    onMarketChange (val) {
      const selected = this.marketList.find(item => item.market_name === val)
      if (selected) {
        this.shopInfo.comlist_v2 = selected.market_name
        this.shopInfo.comlist_v2_1 = selected.market_id
        this.shopInfo.comlist_v2_2 = this.selectedRegion
      } else {
        this.shopInfo.comlist_v2 = val || ''
        this.shopInfo.comlist_v2_1 = ''
      }
    },

    // 经营范围变更
    onSalesTypeChange (val) {
      this.shopInfo.comlist_v6 = val.join(',')
    },

    // 上传店铺logo前的校验
    beforeLogoUpload (file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB')
        return false
      }
      return true
    },

    // 上传营业执照校验
    beforeLicenseUpload (file) {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },

    // 自定义上传logo
    async handleLogoUpload (options) {
      const formData = new FormData()
      formData.append('file', options.file)
      formData.append('comlist2', this.userName)
      // formData.append('user_type', this.userType)
      formData.append('comlistToken', this.userToken)

      try {
        const res = await Request.post(UPLOAD_LOGO_API, formData, {
          headers: { 'Content-Type': 'multipart/form-data', comlistToken: this.userToken }
        })
        if (res.data && res.data.code === 0) {
          const imgUrl = res.data.yasuo_url || res.data.url
          this.shopInfo.mem_img = imgUrl
          this.$message.success('店铺头像上传成功')
        } else {
          this.$message.error(res.data.msg || '上传失败')
        }
      } catch (error) {
        console.error('上传失败', error)
        this.$message.error('上传失败，请重试')
      }
    },

    // 自定义上传营业执照
    async handleLicenseUpload (options) {
      const formData = new FormData()
      formData.append('file', options.file)
      formData.append('comlist2', this.userName)
      // formData.append('user_type', this.userType)
      formData.append('comlistToken', this.userToken)

      try {
        const res = await Request.post(UPLOAD_LICENSE_API, formData, {
          headers: { 'Content-Type': 'multipart/form-data', comlistToken: this.userToken }
        })
        if (res.data && res.data.code === 0) {
          this.shopInfo.zhi_img = res.data.url
          this.$message.success('营业执照上传成功')
        } else {
          this.$message.error(res.data.msg || '上传失败')
        }
      } catch (error) {
        console.error('上传失败', error)
        this.$message.error('上传失败，请重试')
      }
    },

    // 提交表单
    submitForm () {
      this.$refs.shopForm.validate(async (valid) => {
        if (!valid) {
          this.$message.warning('请完善必填信息')
          return false
        }

        // 注意：后端字段对应关系（与原逻辑一致）
        // comlist_v5 存储销售类型文本，comlist_v6 存储经营范围（逗号串）
        const submitParams = {
          user_id: localStorage.getItem('user_id'),
          brand_type: '1',
          sh_id: '', // 新增店铺不传id，让后端生成
          comlist2: this.userName,
          sh_name: this.shopInfo.sh_name,
          sh_type: 0,
          comlist_v1: this.shopInfo.comlist_v1,
          sh_img: this.shopInfo.mem_img,
          zhi_img: this.shopInfo.zhi_img,
          comlist_v2: this.shopInfo.comlist_v2,
          comlist_v2_1: this.shopInfo.comlist_v2_1,
          comlist_v2_2: this.shopInfo.comlist_v2_2,
          comlist_v3: this.shopInfo.comlist_v3,
          comlist_v4: this.shopInfo.comlist_v4,
          comlist_v5: this.shopInfo.comlist_v6, // 注意交换字段
          comlist_v6: this.shopInfo.comlist_v5,
          comlist_v7: this.shopInfo.comlist_v7,
          comlist_v8: this.shopInfo.comlist_v8,
          comlist_v9: this.shopInfo.comlist_v9,
          comlist_v10: this.shopInfo.comlist_v10,
          comlist_v11: this.shopInfo.comlist_v11,
          comlist_v12: this.shopInfo.comlist_v12,
          comlist_m1: this.shopInfo.comlist_m1,
          comlist_v13: this.shopInfo.comlist_v13,
          comlist_v14: this.shopInfo.comlist_v14,
          comlist_v15: this.shopInfo.comlist_v15
        }

        this.submitting = true
        try {
          const res = await Request.post(SUBMIT_API, submitParams, {
            headers: { comlistToken: this.userToken }
          })
          if (res.data && res.data.code === 0) {
            this.$message.success('店铺添加成功')
            // 成功后清空表单或跳转
            this.resetForm()
            // 可选：跳转到店铺列表
            this.$router.push('/index/dashboard')
            localStorage.setItem('sh_id', res.data.jx_id)
          } else {
            this.$message.error(res.data.msg || '添加失败，请重试')
          }
        } catch (error) {
          console.error('提交失败', error)
          this.$message.error('网络错误，请检查后重试')
        } finally {
          this.submitting = false
        }
      })
    },

    // 重置表单
    resetForm () {
      this.shopInfo = {
        sh_name: '',
        comlist_v1: '',
        mem_img: '',
        zhi_img: '',
        comlist_v2: '',
        comlist_v2_1: '',
        comlist_v2_2: '',
        comlist_v3: '',
        comlist_v4: '',
        comlist_v5: '',
        comlist_v6: '',
        comlist_v7: '',
        comlist_v8: '',
        comlist_v9: '',
        comlist_v10: '',
        comlist_v11: '',
        comlist_v12: '',
        comlist_m1: '',
        comlist_v13: '',
        comlist_v14: '',
        comlist_v15: ''
      }
      this.selectedRegion = ''
      this.selectedMarket = ''
      this.marketList = []
      this.$refs.shopForm.clearValidate()
    }
  }
}
</script>

<style lang="scss" scoped>
.add-shop-container {
  padding: 24px;
  background: #f0f2f6;
  height: 90vh;
  overflow: hidden;
  box-sizing: border-box;
}

.form-card {
  max-width: 1200px;
  margin: 0 auto;
  overflow-y: auto;
  height:85vh;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

  .card-header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    .title {
      font-size: 20px;
      font-weight: 600;
      color: #303133;
    }
    .sub-title {
      font-size: 14px;
      color: #909399;
    }
  }
}

.shop-form {
  .form-section {
    margin-bottom: 32px;
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 20px;

    &:last-child {
      border-bottom: none;
    }

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #409eff;
      margin-bottom: 20px;
      padding-left: 10px;
      border-left: 4px solid #409eff;
    }
  }

  .avatar-uploader {
    ::v-deep .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      transition: all 0.3s;
      &:hover {
        border-color: #409eff;
      }
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 120px;
      height: 120px;
      line-height: 120px;
      text-align: center;
      background-color: #fafafa;
      display: inline-block;
      border: 1px dashed #ddd;
      border-radius: 6px;
    }
    .avatar-img {
      width: 120px;
      height: 120px;
      display: block;
      object-fit: cover;
      border-radius: 6px;
      border: 1px solid #e4e7ed;
    }
  }

  .upload-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 8px;
  }

  .sales-checkbox {
    margin-right: 16px;
    margin-bottom: 12px;
  }

  .form-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 8px;
  }

  .form-actions {
    margin-top: 32px;
    text-align: center;
    padding: 16px 0 8px;
    border-top: 1px solid #eaeef2;
  }
}

// 响应式调整
@media (max-width: 768px) {
  .add-shop-container {
    padding: 12px;
  }
  .shop-form .form-section .section-title {
    font-size: 14px;
  }
}
</style>
